import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
} from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { takeUntil } from "rxjs/operators";
import { NzModalService } from "ng-zorro-antd";
import { Subject } from "rxjs";
import { NzNotificationService } from "ng-zorro-antd/notification";
import { RootService } from "../../../../services";
import { SelectMessageService } from "../../../../services/business/selectMessage/selectMessage.service";

@Component({
  selector: "select-message",
  templateUrl: "./select-message.component.html",
  styleUrls: ["./select-message.component.scss"],
})
export class SelectMessageComponent implements OnInit, OnDestroy {
  // @Input() isVisible: boolean;
  // @ts-ignore
  // @ViewChild('lgModal') lgModal;
  unsubscribe$ = new Subject<void>();
  isVisible = false;
  isLoadingBtn = false;
  @Output() loadDataParent = new EventEmitter();
  sms: string;
  type: any;
  brandName: any;

  statuses = [
    { id: 1, label: "Tin nhắn CSKH" },
    { id: 2, label: "Tin nhắn thông tin nội bộ" },
    { id: 3, label: "Tin nhắn quảng cáo" },
  ];
  brandList = [];
  listOfAllData: [];
  query: {};
  constructor(
    private fb: FormBuilder,
    private modalService: NzModalService,
    private rootService: RootService,
    private notification: NzNotificationService,
    private selectMessageService: SelectMessageService
  ) {}

  ngOnInit() {
    this.notification.config({
      nzPlacement: "bottomRight",
    });

    this.selectMessageService
      .listBrandName()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res2) => {
        this.brandList = res2.data;
      });

    this.loadData();
  }

  loadData() {
    this.query = {
      content: this.sms ? this.sms.trim() : "",
      type: this.type ? this.type : "",
      brandId: this.brandName ? this.brandName : "",
    };
    console.log(this.query);
    this.selectMessageService
      .list(this.query)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        this.listOfAllData = res.data;
      });
  }

  search() {
    this.loadData();
  }

  reset() {
    this.sms = undefined;
    this.type = undefined;
    this.brandName = undefined;
    this.loadData();
  }
  currentPageDataChange($event): void {
    // this.listOfDisplayData = $event;
    // this.refreshStatus();
  }

  showModal(id: any): void {
    this.isVisible = true;
  }

  handleCancel(): void {
    this.isVisible = false;
  }

  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
